/* Kingdom Clothing v5 */
(function(){
  'use strict';

  function money(cents){
    return '$' + (cents/100).toFixed(2);
  }

  /* Mobile nav */
  var mobileNav = document.getElementById('MobileNav');
  function openMobile(){ if(mobileNav){ mobileNav.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeMobile(){ if(mobileNav){ mobileNav.classList.remove('is-open'); document.body.style.overflow=''; } }
  document.querySelectorAll('[data-open-mobile]').forEach(function(b){ b.addEventListener('click', openMobile); });
  document.querySelectorAll('[data-close-mobile]').forEach(function(b){ b.addEventListener('click', closeMobile); });

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && revealEls.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {threshold:.12});
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* Cart drawer */
  var drawer = document.getElementById('CartDrawer');
  var itemsEl = document.getElementById('DrawerItems');
  var subtotalEl = document.getElementById('DrawerSubtotal');
  var countEls = [document.getElementById('CartCount')].filter(Boolean);

  function openDrawer(){ if(!drawer) return; drawer.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow=''; }

  document.querySelectorAll('[data-open-cart]').forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); refreshCart(); openDrawer(); });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function(b){
    b.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeDrawer(); closeMobile(); } });

  function cartItemHTML(it){
    var img = it.image
      ? '<img src="' + it.image.replace(/(\.[a-z]+)$/i,'_160x$1') + '" alt="" width="72" height="90" loading="lazy">'
      : '';
    return '<div class="cart-drawer__item">' + img +
      '<div><h4>' + it.product_title + '</h4>' +
      '<p class="muted">' + it.variant_title + '</p>' +
      '<div class="cart-drawer__qty"><button data-dec="' + it.key + '" aria-label="Decrease quantity">−</button>' +
      '<span>' + it.quantity + '</span>' +
      '<button data-inc="' + it.key + '" aria-label="Increase quantity">+</button></div>' +
      '<button class="cart-drawer__remove" data-remove="' + it.key + '">Remove</button></div>' +
      '<strong>' + money(it.final_line_price) + '</strong></div>';
  }

  function renderCart(cart){
    countEls.forEach(function(el){
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if(subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if(!itemsEl) return;
    if(!cart.items.length){
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><p class="muted">Time to fix that.</p></div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(cartItemHTML).join('');
  }

  function refreshCart(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
  }

  function changeQty(key, qty){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
  }

  function addToCart(id, qty){
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:id, quantity:qty || 1})
    }).then(function(r){ return r.json(); }).then(function(){
      refreshCart(); openDrawer();
    }).catch(function(){});
  }

  if(itemsEl){
    itemsEl.addEventListener('click', function(e){
      var t = e.target;
      var key = t.getAttribute('data-dec') || t.getAttribute('data-inc') || t.getAttribute('data-remove');
      if(!key) return;
      var item = null;
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        cart.items.forEach(function(it){ if(it.key === key) item = it; });
        if(t.hasAttribute('data-dec')) changeQty(key, Math.max(0,(item?item.quantity:1)-1));
        else if(t.hasAttribute('data-inc')) changeQty(key, (item?item.quantity:1)+1);
        else if(t.hasAttribute('data-remove')) changeQty(key, 0);
      });
    });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
    btn.addEventListener('click', function(){
      addToCart(btn.getAttribute('data-add-to-cart'), 1);
    });
  });

  /* Product page: variant pills */
  var variantInput = document.querySelector('[data-variant-id]');
  if(variantInput){
    var pills = document.querySelectorAll('.variant-pill');
    var priceEl = document.querySelector('[data-product-price]');
    pills.forEach(function(pill){
      pill.addEventListener('click', function(){
        pills.forEach(function(p){ p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        variantInput.value = pill.getAttribute('data-variant-id');
        var price = pill.getAttribute('data-variant-price');
        if(priceEl && price) priceEl.textContent = money(parseInt(price,10));
      });
    });
    var form = variantInput.closest('form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var qty = form.querySelector('.qty-input');
        addToCart(variantInput.value, qty ? parseInt(qty.value,10) || 1 : 1);
      });
    }
  }

  refreshCart();
})();
